import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

interface LogCodesData {
  logCodes: string[]
}

export const GET_COMMUNICATION_QUERY = gql`
    query logCodes{
        logCodes
    }
`;

export const logCodes = () => useQuery<LogCodesData>(
  GET_COMMUNICATION_QUERY,
  {}
);

export default logCodes;